import { render } from "./EntitlementSituationalModal.vue?vue&type=template&id=f6a36e74&scoped=true"
import script from "./EntitlementSituationalModal.vue?vue&type=script&lang=js"
export * from "./EntitlementSituationalModal.vue?vue&type=script&lang=js"

import "./EntitlementSituationalModal.vue?vue&type=style&index=0&id=f6a36e74&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a36e74"]])

export default __exports__